import { render } from "./CertificateAuth.vue?vue&type=template&id=0bff6348&scoped=true"
import script from "./CertificateAuth.vue?vue&type=script&lang=js"
export * from "./CertificateAuth.vue?vue&type=script&lang=js"

import "./CertificateAuth.vue?vue&type=style&index=0&id=0bff6348&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bff6348"]])

export default __exports__